// src/app/registry/page.jsx
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Gift } from "lucide-react";

export default function RegistryPage() {
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center">
              <Gift className="h-8 w-8 text-primary-foreground" />
            </div>
          </div>
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Gift Registry
          </h1>
          <p className="text-xl text-muted-foreground">
            Create and share your wishlist with loved ones
          </p>
        </div>
        <Card className="backdrop-blur-sm bg-card/70 border-2 border-border">
          <CardHeader>
            <CardTitle>Your Personal Registry</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Create a personalized gift registry for weddings, baby showers, or any special occasion. Coming soon!
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
